import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const accessToken = localStorage.getItem('accessToken')
  const isApiUrl = req.url.startsWith(environment.API_BASE_URL);
  const router = inject(Router);
  if (accessToken && isApiUrl) {
    // Clone the request to add the Authorization header
    req = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${accessToken}`),
    });
  }

  return next(req).pipe(
    catchError((err) => {
      console.log('err', err);
      
      if (err.status === 401) {
        localStorage.clear()
        router.navigate(['']);        
      }
      throw err;
    })
  )
};
